import React from "react";
import Icon from "../Icon";

export default props => (
  <Icon viewBox="0 0 32 32" {...props}>
    <path d="M2 6.5h28m-7.5 6H30m-28 0h14m-14 6h28m-28 6h22" fill="none" />
  </Icon>
);
